import { render } from "./ManageContacts.vue?vue&type=template&id=ca1730d6"
import script from "./ManageContacts.vue?vue&type=script&lang=js"
export * from "./ManageContacts.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__